import React, { useState, useCallback, useRef, useEffect } from "react";
import cn from "classnames";
import Button from "@material-ui/core/Button";
import { useHistory, Link } from "react-router-dom";
import AuthService from "services/auth.service";
import styles from "./Header.module.scss";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import LocalStorageService from "services/tokenlocalstorage.service";
import { getRequestInAssets as getRequest } from "services/axiosAssetsBaseClient";
// import { getRequestInService as getRequestt } from "services/axiosServiceBaseClient";
import { getRequest as enterpriseGetRequest } from "services/axiosBaseClient";
import { getRequest as getRequestAlerts } from "services/axiosBaseClient";
import { getRequestInFileDownload } from "services/axiosFileDownloadService";
import jwt_decode from "jwt-decode";

var localAssetActiveCount;
export default function Header(props) {
  const savedLogoUrl = localStorage.getItem("logoUrl");

  const [displayName, setDisplayName] = useState("");
  const [logoUrl, setLogoUrl] = useState(savedLogoUrl);
  const [dropped, setDropped] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [alertCount, setAlertCount] = useState();
  const [resetButtonDisable, setResetButtonDisable] = useState(true);
  const [applyButtonDisable, setApplyButtonDisable] = useState(true);
  const options = [
    { value: "1", label: "User Profile" },
    { value: "2", label: "Logout" },
  ];

  const filterInitialValue = {
    state: "",
    stateId: "",
    city: "",
    zoneId: "",
    cityId: "",
  };

  const history = useHistory();
  const [showFilter, setShowFilter] = useState("");
  const [isActive, setActive] = useState("false");

  const [headerFilter, setHeaderFilter] = useState(filterInitialValue);

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [zones, setZones] = useState([]);
  const [alertUnreadCount, setAlertUnreadCount] = useState(0);
  const [open, setOpen] = React.useState(false);
  const refOpen = useRef(open);
  const [displayHeader, setDisplayHeader] = useState({
    state: true,
    city: true,
    site: true,
    swapStation: true,
    zone: true,
    enterprise: true,
  });

  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          refOpen.current &&
          ref1.current &&
          ref1.current.contains(event.target)
        ) {
          setOpen(true);
          refOpen.current = true;
        } else {
          if (
            refOpen.current &&
            ref.current &&
            !ref.current.contains(event.target)
          ) {
            setHeaderFilter(filterInitialValue);
            setCityList([]);
            refOpen.current = false;
            setOpen(false);
          } else if (ref.current && ref.current.contains(event.target)) {
            if (refOpen.current) {
              setHeaderFilter(filterInitialValue);
              setCityList([]);
              setOpen(false);
              refOpen.current = false;
            } else {
              const headerFilterObj = JSON.parse(
                LocalStorageService.get("headerFilter")
              );
              if (headerFilterObj !== null) {
                headerFilter.stateId = headerFilterObj.stateId;
                getCities(headerFilterObj.stateId);
                headerFilter.city = headerFilterObj.city;
                headerFilter.cityId = headerFilterObj.cityId;
                headerFilter.zoneId = headerFilterObj.zoneId;
              } else {
                headerFilter.stateId = "";
                headerFilter.city = "";
                headerFilter.cityId = "";
                headerFilter.zoneId = "";
              }

              setOpen(true);
              refOpen.current = true;
            }
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }
  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);
  useOutsideAlerter(wrapperRef, wrapperRefInside);

  useEffect(() => {
    localStorage.setItem("headerBtnType", "off");
    const params = window.location.pathname.toLocaleLowerCase();
    if (
      params.includes("view") ||
      params.includes("add") ||
      params.includes("update") ||
      params.includes("userprofile")
    ) {
      setShowFilter("none");
    } else {
      setShowFilter("block");
    }
  }, []);

  const headerForOtherNav = () => {
    setDisplayHeader({
      ...displayHeader,
      state: true,
      city: true,
      site: true,
      swapStation: true,
      zone: true,
      enterprise: true,
    });
  };

  useEffect(() => {
    localAssetActiveCount = localStorage.getItem("activeTabCount");
    if (
      localAssetActiveCount == "zoneAsset" ||
      localAssetActiveCount == "otherAssets" ||
      localAssetActiveCount == "otherAssetsBattery" ||
      localAssetActiveCount == "usersAsset"
    ) {
      setDisplayHeader({
        ...displayHeader,
        state: localAssetActiveCount == "zoneAsset" ? false : true,
        city: localAssetActiveCount == "zoneAsset" ? false : true,
        site: localAssetActiveCount == "zoneAsset" ? false : true,
        swapStation: localAssetActiveCount == "zoneAsset" ? false : true,
        zone:
          localAssetActiveCount == "zoneAsset" ||
          localAssetActiveCount == "usersAsset" ||
          localAssetActiveCount == "otherAssetsBattery"
            ? false
            : true,
        enterprise: localAssetActiveCount == "zoneAsset" ? true : true,
      });
    }
  }, [props]);

  const ToggleClass = () => {
    setActive(!isActive);
  };

  // const handleClick = (e) => {
  //   console.log(e?.value)
  //   handleProfile();
  // };

  const handleLogout = async (e) => {
    if (e.value == "2") {
      await AuthService.logout();
      history.push("/");
    } else {
      handleProfile();
    }
  };

  const handleProfile = async (e) => {
    history.push("/UserProfile");
  };

  const getCountry = useCallback(async (string) => {
    await getRequest("getCountries")
      .then((res) => {
        if (res.data != null) {
          setCountryList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getStates = useCallback(async (string) => {
    await getRequest("getStates?countryId=1")
      .then((res) => {
        if (res.data != null) {
          setStateList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getCities = useCallback(async (stateId) => {
    if (stateId > 0) {
      await getRequest(`getCities?stateId=${stateId}`)
        .then((res) => {
          if (res.data != null) {
            setCityList(res?.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    } else {
      setCityList([]);
    }
  }, []);

  const getZones = useCallback(async (string) => {
    await getRequest("zone/getZoneInfo")
      .then((res) => {
        if (res.data != null) {
          setZones(res?.data?.zoneList);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getLogoInfo = useCallback(async () => {
    await enterpriseGetRequest(`logo-info`)
      .then((res) => {
        if (res.statusCode === 200 && res.data) {
          setDisplayName(res.data?.displayName);
          if (!logoUrl) {
            downloadProfilePicture(res.data?.logoUrl);
          }
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const downloadProfilePicture = useCallback(async (imgPath) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const { accessToken } = token;
    const decodedToken = jwt_decode(accessToken);
    const userEnterprise = decodedToken.group[0];
    await getRequestInFileDownload(
      `downloadFile/${userEnterprise}?fileName=${imgPath}`
    ).then((res) => {
      if (res) {
        localStorage.setItem("logoUrl", res);
        setLogoUrl(res);
      }
    });
  }, []);

  const getHeaderAlertCount = useCallback(async () => {
    const isAlertSeen = false;
    await enterpriseGetRequest(`bss/getUnreadAlert?isAlertSeen=${isAlertSeen}`)
      .then((res) => {
        // if (res && res.status === 404) {
        setAlertUnreadCount(res?.data);
        // }
      })
      .catch((err) => {
        // setAlertUnreadCount(res?.data);
      });
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setApplyButtonDisable(false);
    if (event.target.name === "zoneId") {
      var index = event.nativeEvent.target.selectedIndex;

      if (value && value > 0) {
        headerFilter.zoneId = event.nativeEvent.target[index].text;
        setHeaderFilter({ ...headerFilter, ["zoneId"]: value });
      } else {
        delete headerFilter["zoneId"];
      }
    }
    if (event.target.name === "stateId") {
      var index = event.nativeEvent.target.selectedIndex;

      getCities(event.target.value);
      headerFilter.state = event.nativeEvent.target[index].text;

      if (value && value > 0) {
        setHeaderFilter({
          ...headerFilter,
          ["stateId"]: value,
          ["cityId"]: "-1",
          ["city"]: "",
        });
      } else {
        delete headerFilter["stateId"];
        delete headerFilter["state"];
      }
    } else if (event.target.name === "cityId") {
      var index = event.nativeEvent.target.selectedIndex;

      headerFilter.city = event.nativeEvent.target[index].text;

      if (value && value > 0) {
        setHeaderFilter({ ...headerFilter, ["cityId"]: value });
      } else {
        delete headerFilter["cityId"];
        delete headerFilter["city"];
      }
    } else {
      setHeaderFilter({ ...headerFilter, [name]: value });
    }
  };

  const handleClick = (btnType) => {
    var hFilter = JSON.parse(JSON.stringify(headerFilter));
    if (btnType == "reset") {
      setResetButtonDisable(true);
      setApplyButtonDisable(true);
      localStorage.setItem("headerBtnType", "reset");
      setHeaderFilter(hFilter);
      setOpen(!open);
      refOpen.current = false;
      hFilter.stateId = "";
      hFilter.cityId = "";
      hFilter.zoneId = "";
      hFilter.state = "";
      hFilter.city = "";
      setCityList([]);
      LocalStorageService.set("headerFilter", JSON.stringify(hFilter));
      props.setHeaderFilter && props.setHeaderFilter(hFilter);
    } else {
      localStorage.setItem("headerBtnType", "apply");
      if ((hFilter?.zoneId && hFilter.zoneId < 0) || hFilter?.zoneId == "") {
        delete hFilter["zoneId"];
      }

      if (hFilter?.cityId && hFilter.cityId < 0) {
        delete hFilter["cityId"];
        delete hFilter["city"];
      }

      if (
        (hFilter?.stateId && hFilter.stateId < 0) ||
        hFilter?.stateId === undefined
      ) {
        hFilter.stateId = "";
        delete hFilter["state"];
        delete hFilter["cityId"];
        delete hFilter["city"];
      }

      LocalStorageService.set("headerFilter", JSON.stringify(hFilter));
      setDropped(!dropped);
      refOpen.current = false;
      setOpen(!open);
      setResetButtonDisable(false);
      setApplyButtonDisable(true);
      props.setHeaderFilter && props.setHeaderFilter(hFilter);
    }
  };
  const getAlertData = useCallback(async () => {
    await getRequestAlerts("bss/getAlerts/filter?&timeFilterEnum=HOUR_24")
      .then((res) => {
        if (res && res?.data) {
          setAlertCount(res?.data.alertCount);
          // setAlertCount("100");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getAlertData();
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      headerFilter.stateId = headerFilterObj?.stateId;
      headerFilter.state = headerFilterObj?.state;
      getCities(headerFilterObj?.stateId);
      headerFilter.city = headerFilterObj?.city;
      headerFilter.zoneId = headerFilterObj?.zoneId;
      setApplyButtonDisable(true);
      if (headerFilter.stateId != "" || headerFilter.zoneId != "")
        setResetButtonDisable(false);
    }
    getCountry();
    getStates();
    getZones();
    getLogoInfo();

    setTimeout(() => {
      getHeaderAlertCount();
    }, 3000);
  }, []);

  return (
    <div
      id="Header_main_block"
      className={`Header ${cn(styles.flex2, styles.flex2_layout)}`}
    >
      <div id="Header_Title_block" className={cn(styles.flex2_item)}>
        <div
          id="Header_Title_Flex"
          className={cn(styles.flex1, styles.flex1_layout1)}
        >
          <div id="Header_Title_imgBlock" className={cn(styles.flex1_item)}>
            <img
              id="Header_Title_img"
              src={require("assets/header1.png").default}
              alt="Rectangle 1092"
              className={cn(styles.box22, styles.box22_layout)}
              onClick={() => props.setNavOpen(!props.navOpen)}
            />
          </div>
          <div className={cn(styles.undefined_spacer)} />
          <Link
            onClick={() => {
              localStorage.setItem("activeTabCount", "other");
            }}
            to="/Dashboard"
          >
            <div id="Header_Title_LogoBlock" className={cn(styles.flex3_item1)}>
              <img
                id="Header_Title_Logo"
                src={
                  logoUrl
                    ? "data:image/png;base64, " + logoUrl
                    : require("assets/headerJioLogo.png").default
                }
                alt="Ellipse 32"
                className={cn(styles.bss_ic, styles.bss_ic_layout)}
                // onClick={() => alert('It is clickable')}
              />
              <div
                id="Header_Title_HeadingBlock"
                className={cn(styles.flex3_spacer1)}
              />
              <h1
                id="Header_Title_Heading"
                className={cn(styles.big_title, styles.big_title_layout)}
              >
                {displayName ? displayName : ""}
              </h1>
            </div>
          </Link>
          {/* <div className={cn(styles.flex3_spacer1)} /> */}
          {/* <h1 className={cn(styles.big_title, styles.big_title_layout)}>
            {"BSS"}
          </h1> */}
        </div>
      </div>
      <div className={cn(styles.undefined_spacer3)} />
      <div id="Header_icon_container" className={cn(styles.undefined_item1)}>
        <div
          id="Header_icon_container1"
          className={cn(styles.group2, styles.group2_layout)}
        >
          {/* <div
            style={{
              '--src': `url(${
                require('assets/header4.png').default
              })`
            }}
            className={cn(styles.block21, styles.block21_layout)}
          /> */}

          <div
            id="Header_icon_group"
            className={cn(styles.block45, styles.block45_layout)}
          >
            <div
              id="Header_Filter_Icon"
              className={cn(styles.group5, styles.group5_layout)}
            >
              <div
                id="Header_Filter_Icon1"
                className={setShowResults ? cn(styles.block45_item) : null}
                ref={wrapperRef}
                style={{ display: showFilter }}
              >
                <img
                  id="Header_Filter_IconImg"
                  src={require("assets/header3.png").default}
                  alt="..."
                  className={cn(styles.filter_ic, styles.filter_ic_layout)}
                  //onClick={() => setDropped(!dropped)}
                  onClick={() => {
                    if (localAssetActiveCount === "other") {
                      // setDisplayHeader(LocalStorageService?.getDisplayHeader());
                      headerForOtherNav();
                    }
                  }}
                />
              </div>
            </div>

            {/* implement here  vikas */}
            {open ? (
              localAssetActiveCount !== "zoneAsset" ? (
                <div
                  id="Header_Filter_Dropdown"
                  className={cn(
                    styles.status1_block,
                    styles.status1_block_layout
                  )}
                  ref={wrapperRefInside}
                >
                  {displayHeader?.state && (
                    <div id="Header_State_Dropdown">
                      <select
                        style={{ width: "80%", height: "35px" }}
                        name="stateId"
                        id="stateId"
                        onChange={handleChange}
                        value={headerFilter.stateId}
                      >
                        <option value="-1" selected>
                          Select State
                        </option>
                        {stateList.map((obj) => {
                          return <option value={obj.id}>{obj.name}</option>;
                        })}
                      </select>
                    </div>
                  )}

                  {displayHeader?.city && (
                    <div id="Header_city_Dropdown">
                      <select
                        style={{ width: "80%", height: "35px" }}
                        name="cityId"
                        id="cityId"
                        onChange={handleChange}
                        value={headerFilter.cityId}
                      >
                        <option value="-1" selected>
                          Select City
                        </option>
                        {cityList.map((obj) => {
                          return <option value={obj.id}>{obj.name}</option>;
                        })}
                      </select>
                    </div>
                  )}

                  {displayHeader?.zone && (
                    <div id="Header_Zone_Dropdown">
                      <select
                        style={{ width: "80%", height: "35px" }}
                        name="zoneId"
                        id="zoneId"
                        onChange={handleChange}
                        value={headerFilter.zoneId}
                      >
                        <option value="-1" selected>
                          Select Zone
                        </option>
                        {zones.map((obj) => {
                          return <option value={obj.zoneId}>{obj.zone}</option>;
                        })}
                      </select>
                    </div>
                  )}

                  <div id="Header_filter_button">
                    <Button
                      id="Header_reset_button"
                      style={{
                        background: "#E3324C",
                        color: "white",
                        margin: "15px 0px 6px 35px",
                        width: "85px",
                        height: "28px",
                      }}
                      disabled={resetButtonDisable}
                      onClick={() => {
                        handleClick("reset");
                      }}
                      className={cn(styles.filter_ic, styles.filter_ic_layout)}
                    >
                      Reset
                    </Button>

                    <Button
                      id="Header_apply_button"
                      style={{
                        background: "#23297A",
                        color: "white",
                        margin: "15px 0px 6px 20px",
                        width: "85px",
                        height: "28px",
                      }}
                      disabled={applyButtonDisable}
                      onClick={() => {
                        handleClick("apply");
                      }}
                    >
                      Apply
                    </Button>
                  </div>
                </div>
              ) : (
                <div
                  className={cn(
                    styles.status1_block,
                    styles.status1_block_layout,
                    styles.no_filter_container
                  )}
                  ref={wrapperRefInside}
                >
                  <h1>No Filter Criteria!</h1>
                </div>
              )
            ) : (
              <></>
            )}

            {/* upto here */}

            <div className={cn(styles.block45_spacer)} />
            <div id="Header_Alerts" className={cn(styles.flex6_item1)}>
              <Link to="/Dashboard">
                <div
                  id="Header_Alerts_icon"
                  className={cn(styles.group4, styles.group4_layout)}
                >
                  {/* <div
                    className={cn(styles.group5, styles.group5_layout)}
                    // onClick={() => alert('It is clickable')}
                  > */}
                  <Link to="/Alerts">
                    <>
                      <div id="Header_Alerts_icon1">
                        <img
                          id="Header_AlertsImg"
                          src={require("assets/bell_white.svg").default}
                          alt="1936"
                          className={cn(
                            styles.notification_ic,
                            styles.notification_ic_layout
                          )}
                        />
                        <span
                          id="Header_notification_count"
                          className={cn(styles.block46_IconCount)}
                        >
                          {" "}
                          {alertCount >= 100 ? "99+" : alertCount}{" "}
                        </span>
                      </div>
                    </>
                  </Link>

                  {/* </div> */}
                </div>
              </Link>
            </div>
            <div className={cn(styles.block46_spacer1)} />

            {/* <div className={cn(styles.block13_item1)}> */}
            <Link to="/UserProfile">
              <div
                id="Header_Profile_block"
                className={cn(styles.text_body4, styles.text_body4_layout)}
              >
                <div
                  id="Header_Profile"
                  className={cn(styles.profile_ic, styles.profile_ic_layout)}
                >
                  <img
                    id="Header_Profile_Img"
                    src={
                      !props.image || props?.image?.length == 0
                        ? require("assets/smallprofile.png").default
                        : "data:image/png;base64, " + props?.image
                    }
                    alt={require("assets/smallprofile.png").default}
                    //
                    //  onClick={() => alert('vikas')}

                    style={{
                      borderRadius: "100%",
                      width: "25px",
                      height: "25px",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                  />
                </div>
              </div>
            </Link>
            <div className={cn(styles.block46_spacer4)} />
            <div
              id="Header_Profile_dropdown"
              className={cn(styles.text_body4, styles.text_body4_layout)}
            >
              <Dropdown
                menuClassName={cn(styles.dropdown_style1)}
                controlClassName={cn(styles.dropdown_style)}
                options={options}
                value={props.username}
                onChange={handleLogout}
              />
            </div>
            {/* handleLogout */}
            {/* </Dropdown> */}

            {/* <div className={cn(styles.block46_spacer2)} /> */}

            {/* <div className={cn(styles.text_body4, styles.text_body4_layout)}>
            <Dropdown 
            menuClassName={cn(styles.dropdown_style1)} 
            controlClassName={cn(styles.dropdown_style)} 
            options={options} 
            value={props.username} 
            onChange={handleClick} />
            </div> */}
            {/* </Dropdown> */}

            {/* <div className={cn(styles.block46_item1)}>
              <div className={cn(styles.filter_ic_block, styles.filter_ic_block_layout)}>
                <img

                  src={require('assets/header6.png').default}
                  alt="1081"
                  className={cn(styles.box19, styles.box19_layout)}
                  onClick={handleClick}
                />
  
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

Header.inStorybook = true;
